export default {
  preview: {
    label: 'Podgląd',
    tooltip: 'Podgląd strony zamówień online w nowej karcie.',
  },
  buttons: {
    visit_online_store: 'Sklep internetowy',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Nie udało się uruchomić portalu zamówień',
  },
};
